import { render } from "./photo_admin_dashboard.vue?vue&type=template&id=856f9a3c&scoped=true"
import script from "./photo_admin_dashboard.vue?vue&type=script&lang=js"
export * from "./photo_admin_dashboard.vue?vue&type=script&lang=js"

import "./photo_admin_dashboard.vue?vue&type=style&index=0&id=856f9a3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-856f9a3c"]])

export default __exports__